// src/features/knowledge-management/preavvisi.js
//
// Preavvisi di chiusura dell'esperienza — AF v2.0 §6 (Esperienza) e UC-P03-02.
// Il backend li vuole in giorni (`preavvisi_giorni`, ammessi 60/30/14/7/3/1);
// l'interfaccia li mostra come in un promemoria di calendario. Il promemoria
// alla data prevista è implicito, obbligatorio e non disattivabile (V25).

export const PREAVVISI = [
  { giorni: 60, label: '2 mesi prima' },
  { giorni: 30, label: '1 mese prima' },
  { giorni: 14, label: '2 settimane prima' },
  { giorni: 7, label: '1 settimana prima' },
  { giorni: 3, label: '3 giorni prima' },
  { giorni: 1, label: '1 giorno prima' },
];

// UC-P03-01 passo 4: «valori proposti: un mese e una settimana prima».
export const PREAVVISI_PROPOSTI = [30, 7];

export function labelPreavviso(giorni) {
  return PREAVVISI.find((p) => p.giorni === Number(giorni))?.label || `${giorni} giorni prima`;
}

function oggiIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function sottraiGiorni(iso, giorni) {
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() - giorni);
  return dt.toISOString().slice(0, 10);
}

export function formatDataIt(iso) {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && y ? `${d}/${m}/${y}` : String(iso);
}

/* Anteprima dei promemoria (UC-P03-02 passo 8 e flusso alternativo 3):
   per ogni preavviso la data effettiva e se ricade nel passato — in quel
   caso non sarà emesso, i promemoria non sono retroattivi. */
export function anteprimaPromemoria(dataPrevista, preavvisiGiorni) {
  if (!dataPrevista) return [];
  const oggi = oggiIso();
  const voci = [...preavvisiGiorni]
    .map(Number)
    .sort((a, b) => b - a)
    .map((g) => {
      const data = sottraiGiorni(dataPrevista, g);
      return { giorni: g, label: labelPreavviso(g), data, trascorso: data < oggi, obbligatorio: false };
    });
  voci.push({
    giorni: 0,
    label: 'Alla data prevista (obbligatorio)',
    data: String(dataPrevista).slice(0, 10),
    trascorso: String(dataPrevista).slice(0, 10) < oggi,
    obbligatorio: true,
  });
  return voci;
}

export { oggiIso };
